"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _shortid = _interopRequireDefault(require("shortid"));
var _styledComponents = require("styled-components");
var _AlertCircle = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/01-Interface-Essential/14-Alerts/AlertCircle"));
var _FormField = require("./FormField.style");
var _functions = require("./functions");
var _htmlCheck = _interopRequireDefault(require("@berlitz/max-utils/lib/htmlCheck"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// eslint-disable-next-line react/display-name
var FormField = /*#__PURE__*/(0, _react.memo)(function (props) {
  var _useState = (0, _react.useState)(_shortid.default.generate()),
    _useState2 = _slicedToArray(_useState, 1),
    labelId = _useState2[0];
  var _useState3 = (0, _react.useState)(_shortid.default.generate()),
    _useState4 = _slicedToArray(_useState3, 1),
    helpTextId = _useState4[0];
  var children = props.children,
    className = props.className,
    disableMargin = props.disableMargin,
    hideLabel = props.hideLabel,
    id = props.id,
    invalid = props.invalid,
    label = props.label,
    light = props.light,
    required = props.required,
    validationMessage = props.validationMessage,
    validationMessageLeft = props.validationMessageLeft,
    halfMargin = props.halfMargin;
  return /*#__PURE__*/_react.default.createElement(_FormField.Wrapper, {
    light: light,
    className: className,
    disableMargin: disableMargin,
    halfMargin: halfMargin
  }, label && /*#__PURE__*/_react.default.createElement(_FormField.Label, {
    htmlFor: id || labelId,
    hideLabel: hideLabel,
    light: light,
    "data-key": "max-form__label"
  }, _htmlCheck.default.test(label) ? /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: label
    }
  }) : label, required && /*#__PURE__*/_react.default.createElement(_FormField.Asterisk, {
    light: light
  }, "*")), /*#__PURE__*/_react.default.createElement(_FormField.InputWrapper, null, /*#__PURE__*/_react.default.cloneElement(children, {
    id: id || labelId,
    required: required,
    invalid: invalid,
    light: light,
    hideLabel: hideLabel
  })), invalid && /*#__PURE__*/_react.default.createElement(_FormField.ValidationPopUp, {
    validationMessageLeft: validationMessageLeft,
    id: helpTextId
  }, /*#__PURE__*/_react.default.createElement(_AlertCircle.default, {
    title: "Warning",
    color: "warning"
  }), /*#__PURE__*/_react.default.createElement(_FormField.CaptionMessage, null, validationMessage)));
}, _functions.areEqual);
FormField.defaultProps = {
  hideLabel: false,
  invalid: false,
  required: false,
  validationMessage: '',
  validationMessageLeft: false,
  light: false
};
var _default = (0, _styledComponents.withTheme)(FormField);
exports.default = _default;